import api from '@/modules/api.service';
import type { RelatorioAtividadeDto } from '../relatorios-atividades.types';

export type DiaComparecimentoAdjacenteDto =
  NonNullable<RelatorioAtividadeDto['diasComparecimentoAdjacentes']>[number];

export async function buscarDiasComparecimentoAdjacentesUseCase(
  defensorId: number,
  defensoriaId: number,
  mes: string | number,
  ano: number,
  tipo: 'civil' | 'criminal' = 'civil',
  excludeRelatorioId?: number,
): Promise<DiaComparecimentoAdjacenteDto[]> {
  try {
    const params: Record<string, string | number> = {
      defensorId,
      defensoriaId,
      mes: String(mes),
      ano,
      tipo,
    };
    if (excludeRelatorioId) params.excludeRelatorioId = excludeRelatorioId;

    const response = await api.get<DiaComparecimentoAdjacenteDto[]>(
      '/relatorios/atividades/comparecimento-adjacentes',
      { params },
    );
    return response.data ?? [];
  } catch (error) {
    console.error('Erro ao buscar dias de comparecimento adjacentes:', error);
    return [];
  }
}
